
import { UtilParam } from './UtilParam';
import { OperationParam } from './OperationParam';

export class Action {
  eventName: string;
  action: string;
  displayName: string;

  actionParams: string[];
  conditionParams: string[];
  utilParams: UtilParam[];
  confirmField: string;
  confirmValue: string;

  type: ActionType;
  isAsync: boolean;

  preAction: Action;
  postAction: Action;
  pastAction: Action;

  params: OperationParam[];

  response: any;

  OperationType: string;
  Entity: string;
  Operation: string;
  Endpoint: string;

  constructor(eventName: string, action: string, type: ActionType) {
    this.eventName = eventName;
    this.action = action;
    this.type = type;

    this.preAction = null;
    this.postAction = null;

    this.actionParams = null;
    this.conditionParams = null;
    this.utilParams = null;

    this.response = null;

  }
}

export enum ActionType {
  API = 0,
  THIS = 1,
  OTHER = 2,
  VIEW = 3,
  CRUD = 4,
  ACTION = 5
}
